
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-fundraising",
      function () {
        return require("private-next-pages/free-fundraising.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-fundraising"])
      });
    }
  